import { render, staticRenderFns } from "./Overage.vue?vue&type=template&id=8097e2ca&"
import script from "./Overage.vue?vue&type=script&lang=js&"
export * from "./Overage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports